
const Airtable = require('airtable');
const base = new Airtable({apiKey: 'keyNVeUpVociTbelZ'}).base('appw68qCXFbHbYoFq');


export function saveFeedbackToAirtable(data){
  const { question, feeback, level, section, username, uuid, classField } = data

  base('Table 1').create([
    {
      "fields": {
        "Question": question,
        "feeback": feeback,
        "username": username,
        "class": classField,
        "level": level+"",
        "section": section,
        "session uuid": uuid,
      }
    }
  ], function(err, records) {
    if (err) {
      console.error(err);
      return;
    }
    records.forEach(function (record) {
      console.log(record.getId());
    });
  });

}
